module.exports = __webpack_public_path__ + "img/grs.b95e5f98.svg";